import client from '@/http/requests/client'
import tax from '@/http/requests/tax'

export default {
  fetchIvaReturnRequestList({ commit }, data) {
    return new Promise((resolve, reject) => {
      tax
        .IvaReturnList(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_TAX_TABLE_LIST', response.data.data)
          } else {
            commit('SET_TAX_TABLE_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  clearIvaReturnRequestList({ commit }) {
    return new Promise(() => {
      commit('CLEAR_TAX_TABLE_LIST')
    })
  },
  fetchClientList({ commit }, data = null) {
    return new Promise((resolve, reject) => {
      client
        .list(data)
        .then(response => {
          commit('SET_CLIENT_LIST', response.data.clients)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addTax({ commit }, data) {
    return new Promise((resolve, reject) => {
      tax
        .addTaxReturn(data)
        .then(response => {
          commit('ADD_TAX', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTax({ commit }, data) {
    return new Promise((resolve, reject) => {
      tax
        .updateTaxReturn(data)
        .then(response => {
          commit('UPDATE_TAX', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }  
}
